import { useEffect, useState, forwardRef } from 'react';
import FooterNav from '../../components/dashboard/FooterNavReadyStock';
import Navbar from '../../components/dashboard/Navbar';
import Slider from '../../components/Slider';
import Main from '../../components/dashboard/Main';
import Products from '../../components/dashboard/Products';
import ReadyStockCheckingOut from '../../components/dashboard/ReadyStockCheckingOut';

import axios from  'axios';
import jwtDecode from 'jwt-decode';
import { Link, useNavigate } from "react-router-dom";
import styledComponent from "styled-components";
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

import {
    Box,
    Divider,
    Grid,
    Typography,
    TextField,
    Button,
    Menu,
    MenuItem,
    Link as MuiLink,
    ListItemIcon,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    Modal,
    InputBase,
    InputLabel,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Snackbar,
    Select,
    Stack,
    Pagination,
    Paper
} from "@mui/material";

import { blueGrey } from '@mui/material/colors';
import MuiAlert from '@mui/material/Alert';
import { tableCellClasses } from '@mui/material/TableCell';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';

import {
  Search,
  Notifications,
  ShoppingCart,
  Email,
  LocalAtm,
  ExitToApp,
  PowerOffRounded
} from "@material-ui/icons";

import SearchIcon from '@mui/icons-material/Search';
import mainLogo from '../../assets/logo.png';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DeleteIcon from '@mui/icons-material/Delete';
import FooterNavReadyStock from '../../components/dashboard/FooterNavReadyStock';

import { Formik } from 'formik';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '68vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Container = styledComponent.div`
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const Wrapper = styledComponent.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
      return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const Transaksi = ({ Cart, UpdatedCart }) => {

    const navigate = useNavigate();
    const [value, setValue] = useState(0);
    const [tabIndex, setTabIndex] = useState({});
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const [search, setSearch] = useState(null);

    const [page, setPage] = useState({ value: 1 });
    const [pageInfo, setPageInfo] = useState(null);
    const [pageSize, setPageSize] = useState({ value: 10 });

    const [pageLunas, setPageLunas] = useState({ value: 1 });
    const [pageInfoLunas, setPageInfoLunas] = useState(null);
    const [pageSizeLunas, setPageSizeLunas] = useState({ value: 10 });
    
    const [dataBelumBayar, setDataBelumBayar] = useState([]);
    const [dataLunas, setDataLunas] = useState([]);
    const [cartState, setCartState] = useState([]);
    const [jmlState, setJmlState] = useState(0);
    const [totalState, setTotalState] = useState(0);
    
    const [isCheckedOut, setCheckedOut] = useState(false);
    const [token, setToken] = useState(
      JSON.parse(localStorage.getItem('token')) !== null ? 
          JSON.parse(localStorage.getItem('token')).token :
          null
    );

    const handlePage = (event, value) => {
      setPage({ value });
      const serviceToken = window.localStorage.getItem('serviceToken');
      const getData = async () => {
          try {
            const konfirmasi = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/transaksi`, {
              headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
              },
              params: {
                  lunas: 0,
                  page: value,
                  perPage: pageSize.value
              }
            });
            let num = (value - 1) * (pageSize.value);
            setDataBelumBayar(konfirmasi.data.result.data.map((v) => {
              num+=1
              return {...v, no: num};
            }));
            const pageInfoRes = Object.keys(konfirmasi.data.result)
                .filter((key) => {
                    if (key !== 'data') return true;
                    return false;
                })
                .reduce((cur, key) => Object.assign(cur, { [key]: konfirmasi.data.result[key] }), {});
            setPageInfo(pageInfoRes);
          } catch (err) {
              console.error(err);
          }
      };
      getData();
    };

    const handlePageLunas = (event, value) => {
      setPageLunas({ value });
      const serviceToken = window.localStorage.getItem('serviceToken');
      const getData = async () => {
          try {
            const konfirmasi = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/transaksi`, {
              headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
              },
              params: {
                  lunas: 1,
                  page: value,
                  perPage: pageSize.value
              }
            });
            let num = (value - 1) * (pageSize.value);
            setDataLunas(konfirmasi.data.result.data.map((v) => {
              num+=1
              return {...v, no: num};
            }));
            const pageInfoRes = Object.keys(konfirmasi.data.result)
                .filter((key) => {
                    if (key !== 'data') return true;
                    return false;
                })
                .reduce((cur, key) => Object.assign(cur, { [key]: konfirmasi.data.result[key] }), {});
            setPageInfoLunas(pageInfoRes);
          } catch (err) {
              console.error(err);
          }
      };
      getData();
    };

    const [openDialog, setOpenDialog] = useState(false);
    const [updateTransaksi, setUpdateTransaksi] = useState({});

    const handleCloseDialog = () => {
      setOpenDialog(false);
      setUpdateTransaksi({});
    };

    const handleOpenDialog = (value) => {
      setOpenDialog(true);
      setUpdateTransaksi(value);
    };

    const getData = async (searchParam) => {
      try {
        const konfirmasi = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/transaksi`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
          },
          params: {
            search: searchParam,
            lunas: 0,
            page: page.value,
            perPage: pageSize.value
          }
        });
        let num = 0;
        setDataBelumBayar(konfirmasi.data.result.data.map((v) => {
          num+=1
          return {...v, no: num};
        }));
        const pageInfoRes = Object.keys(konfirmasi.data.result)
          .filter((key) => {
              if (key !== 'data') return true;
              return false;
          })
          .reduce((cur, key) => Object.assign(cur, { [key]: konfirmasi.data.result[key] }), {});
        setPageInfo(pageInfoRes);
      } catch (err) {
        console.log(err);
      }
    };
    const getDataLunas = async (searchParam) => {
      try {
        const konfirmasi = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/transaksi`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
          },
          params: {
            search: searchParam,
            lunas: 1,
            page: pageLunas.value,
            perPage: pageSizeLunas.value
          }
        });
        let num = 0;
        setDataLunas(konfirmasi.data.result.data.map((v) => {
          num+=1
          return {...v, no: num};
        }));
        const pageInfoRes = Object.keys(konfirmasi.data.result)
          .filter((key) => {
              if (key !== 'data') return true;
              return false;
          })
          .reduce((cur, key) => Object.assign(cur, { [key]: konfirmasi.data.result[key] }), {});
        setPageInfoLunas(pageInfoRes);
      } catch (err) {
        console.log(err);
      }
    };

    useEffect(() => {
      const getCart = async () => {
        try {
          const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
          });
          setCartState(cartData.data.result);
        } catch (err) {
          console.log(err);
        }
      };
      if(!verifyToken(token)){
        localStorage.removeItem('token');
        navigate('/');
      }
      getData();
      getDataLunas();
      getCart();
    },[]);

    return (
        <div>
            <Navbar cartState={cartState} UpdatedCartState={setCartState} jmlState={jmlState} totalState={totalState} UpdatedTotalState={setTotalState} UpdatedJmlState={setJmlState} />
            <Container>
              <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Sudah terima barang dan ubah transaksi menjadi selesai ?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseDialog}>Batal</Button>
                  <Button
                    onClick={async () => {
                      try {
                        await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/transaksi/selesai`, updateTransaksi, {
                          headers: {
                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                          }
                        });
                        const konfirmasi = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/transaksi`, {
                          headers: {
                              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                          },
                          params: {
                              lunas: 1,
                              page: value,
                              perPage: pageSize.value
                          }
                        });
                        let num = (value - 1) * (pageSize.value);
                        setDataLunas(konfirmasi.data.result.data.map((v) => {
                          num+=1
                          return {...v, no: num};
                        }));
                        const pageInfoRes = Object.keys(konfirmasi.data.result)
                            .filter((key) => {
                                if (key !== 'data') return true;
                                return false;
                            })
                            .reduce((cur, key) => Object.assign(cur, { [key]: konfirmasi.data.result[key] }), {});
                        setPageInfoLunas(pageInfoRes);
                        handleCloseDialog();
                      } catch (err) {
                        console.log(err);
                      }
                    }}
                  >
                    Ya
                  </Button>
                </DialogActions>
              </Dialog>
              <Grid container spacing={1}>
                <Grid item xs={12} sx={{ margin: '10px 14px'}}>
                    <Typography variant="h5" fontWeight="700">Transaksi</Typography>
                </Grid>
                <Grid item xs={12} my={1}>
                  <Formik
                      initialValues={{ search: null }}
                      validate={async (values) => {
                          const errors = {};
                          if (!values.search) {
                              errors.search = 'Required';
                          }
                          if (values.search === '') {
                              setSearch(null);
                              try {
                                  getData();
                                  getDataLunas();
                              } catch (err) {
                                  console.log(err);
                              }
                          }
                          return errors;
                      }}
                      onSubmit={async (values, { setSubmitting }) => {
                          setPage({ value: 1 });
                          try {
                              setSearch(values.search);
                              getData(values.search);
                              getDataLunas(values.search);
                          } catch (err) {
                              console.log(err);
                          }
                      }}
                  >
                      {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                          /* and other goodies */
                      }) => (
                          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                              <Paper
                                component="div"
                                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: {xs: '100%', md: '50%'}}}
                              >
                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    required
                                    name="search"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Cari transaksi"
                                    inputProps={{ 'aria-label': 'cari transaksi' }}
                                />
                              <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                  <SearchIcon />
                              </IconButton>
                              </Paper>
                          </form>
                      )}
                  </Formik>
                </Grid>
                <Grid item xs={12} my={1}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                      {<Tab label="Belum Bayar" {...a11yProps(0)} />}
                      {<Tab label="Lunas" {...a11yProps(1)} />}
                    </Tabs>
                  </Box>
                  
                  <TabPanel value={value} index={0}>
                    <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
                      <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 320 }}>
                        <TableHead>
                          <TableRow>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">No</Typography></TableCell>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">Data</Typography></TableCell>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">Invoice</Typography></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {dataBelumBayar.map((row) => (
                            <TableRow
                              key={row.idorder}
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell>{row.no}</TableCell>
                                <TableCell>
                                  <Typography variant="body2" fontWeight="700">{row.tgl}</Typography>
                                  <Typography variant="body1">{row.namamitra || row.namaagen}</Typography>
                                  <Typography variant="body2" fontWeight="600">Payment: {row.payment}</Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body1">
                                    <a href={`/dashboard/readystock/detailorder?invoice=${row.invoice}`}>#{row.invoice}</a>
                                  </Typography>
                                  <Typography variant="body2">Status: {row.statusnya}</Typography>
                                </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Stack spacing={0} my={1}>
                      <Pagination
                        count={pageInfo ? pageInfo.last_page : 10}
                        color="primary"
                        page={page.value}
                        onChange={handlePage}
                        variant="outlined"
                        shape="rounded"
                      />
                    </Stack>
                  </TabPanel>


                  <TabPanel value={value} index={1}>
                    <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
                      <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 400 }}>
                        <TableHead>
                          <TableRow>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">No</Typography></TableCell>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">Data</Typography></TableCell>
                              <TableCell><Typography variant="subtitle2" fontWeight="700">Invoice</Typography></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {dataLunas.map((row) => (
                            <TableRow
                              key={row.idorder}
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell>{row.no}</TableCell>
                                <TableCell width="70">
                                  <Typography variant="body2" fontWeight="700">{row.tgl}</Typography>
                                  <Typography variant="body1">{row.namamitra || row.namaagen}</Typography>
                                  <Typography variant="body2" fontWeight="600">Payment: {row.payment}</Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body1">
                                    <a href={`/dashboard/readystock/detailorder?invoice=${row.invoice}`}>#{row.invoice}</a>
                                  </Typography>
                                  <Typography variant="body2" fontWeight="700">Status: {row.statusnya}</Typography>
                                  {row.statusnya != 'Selesai' && (
                                    <Button
                                      size="small"
                                      variant="contained"
                                      onClick={() => handleOpenDialog({ invoice: row.invoice })}
                                    >
                                      <Typography variant="caption">Sudah Terima Barang</Typography>
                                    </Button>
                                  )}
                                </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Stack spacing={0} my={1}>
                      <Pagination
                        count={pageInfoLunas ? pageInfoLunas.last_page : 10}
                        color="primary"
                        page={pageLunas.value}
                        onChange={handlePageLunas}
                        variant="outlined"
                        shape="rounded"
                      />
                    </Stack>
                  </TabPanel>
                </Grid>
                
              </Grid>
            </Container>
            <FooterNavReadyStock />
        </div>
    )
}

export default Transaksi
